import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';

import { FormlyRadioOption } from '../../../models';
import { FormlyFieldBaseComponent } from '../formly-field-base.component';

/**
 * A radio group: one radio per `props.radioOptions` entry, all on the field's one control (Ross
 * Un-do routines, 5 Oct 2026: the first screen to need a choice of several, with the closed choices
 * shown and explained rather than hidden).
 */
@Component({
  selector: 'app-formly-radio',
  templateUrl: './formly-radio.component.html',
  styleUrl: './formly-radio.component.scss',
  imports: [FormsModule, ReactiveFormsModule, FormlyModule],
})
export class FormlyRadioComponent extends FormlyFieldBaseComponent {
  optionId(option: FormlyRadioOption): string {
    return `${this.field.key}-${option.value}`;
  }
}
